import { getItemByY, MIN_BLOCK } from "./utils";
import {
  MODE_EDIT,
  MODE_RESIZE_BOTTOM,
  MODE_NONE,
  STATUS_CREATING,
} from "./actions";
import { v4 as uuidv4 } from "uuid";
import { BlockWithStatus, CalendarState, MouseDownAction } from "./types";

export const mouseDownReducer = (
  state: CalendarState,
  action: MouseDownAction
): CalendarState => {
  const { region, brush } = action.payload;
  let { item, mode } = getItemByY(state, region.date, region.y) || {};
  console.log(region);

  if (state.mode === MODE_EDIT) {
    if (item != null) {
      return {
        ...state,
        lastDown: Date.now(),
        mode,
        activeItem: item.id,
        // TODO fix this atrocity
        offset: {
          x: 0,
          y: 0,
          ...(region as any).offset,
        },
        dragType: region.type,
      };
    } else {
      return {
        ...state,
        lastDown: Date.now(),
        mode: MODE_NONE,
        activeItem: null,
      };
    }
  }

  if (item == null) {
    if (region.minute > state.shownRange[1] - MIN_BLOCK) {
      return state;
    }

    const newItem: BlockWithStatus = {
      id: uuidv4(),
      date: region.date,
      start: region.minute,
      length: MIN_BLOCK,
      description: brush.description ?? "",
      color: brush.color,
      status: STATUS_CREATING,
      tags: brush.tags,
    };

    return {
      ...state,
      lastDown: Date.now(),
      mode: MODE_RESIZE_BOTTOM,
      items: state.items.concat([newItem]),
      activeItem: newItem.id,
    };
  }

  return {
    ...state,
    lastDown: Date.now(),
    mode,
    activeItem: item.id,
    // TODO fix this atrocity
    offset: {
      x: 0,
      y: 0,
      ...(region as any).offset,
    },
    dragType: region.type,
  };
};
